import { Close } from '@mui/icons-material';
import { Divider, IconButton, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Tooltip from '@mui/material/Tooltip';
import { cloneElement, type ReactElement, useEffect, useState } from 'react';

export default function TooltipModal({
  title,
  children,
}: {
  title: string;
  children: ReactElement<{ onClick?: () => void }>;
}) {
  const [isTouch, setIsTouch] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const handleTouchStart = () => setIsTouch(true);

    window.addEventListener('touchstart', handleTouchStart, { once: true });

    return () => {
      window.removeEventListener('touchstart', handleTouchStart);
    };
  }, []);

  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);

  if (isTouch) {
    return (
      <>
        {cloneElement(children, { onClick: handleOpenModal })}
        <Modal open={modalOpen} onClose={handleCloseModal}>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              bgcolor: 'background.paper',
              borderRadius: 2,
              boxShadow: 24,
              minWidth: 300,
              maxWidth: '90%',
              outline: 'none',
            }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                px: 2,
                py: 1,
              }}>
              <Typography variant="h6">Hinweis</Typography>
              <IconButton onClick={handleCloseModal}>
                <Close />
              </IconButton>
            </Box>
            <Divider />
            <Box sx={{ p: 2 }}>{title}</Box>
          </Box>
        </Modal>
      </>
    );
  }

  return (
    <Tooltip title={title} enterTouchDelay={0} leaveTouchDelay={3000}>
      {children}
    </Tooltip>
  );
}
